<template>
  <Modal v-model="modalValue" title="审核" width="500" @on-cancel="modalCancel">
    <Row>
      <Col span="20" offset="1">
        <Form ref="addForm" :model="form" :rules="rules" :label-width="100">
          <FormItem label="审核状态" prop="status">
            <Select v-model="form.status" @on-change="statusChange">
              <Option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.value"></Option>
            </Select>
          </FormItem>
          <FormItem label="审核意见" prop="remark">
            <Input type="textarea" placeholder="请输入审核意见" v-model="form.remark"></Input>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
      <Button type="primary" :loading="btnLoading" @click="modalConfirm">确认</Button>
    </div>
  </Modal>
</template>

<script>
  import * as apiActivity from '@/api/activity/activity'
  export default {
    name: 'add-card',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      type: {
        type: [Number, String],
        default: 1,
      },
      id: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        btnLoading: false,
        form: {
          status: '',
          remark: '',
        },
        statusList: [
          { name: '审核通过', value: '1' },
          { name: '审核不通过', value: '2' },
        ],
        rules: {
          status: [{ required: true, message: '审核状态不能为空', trigger: 'change' }],
          remark: [{ required: true, message: '审核意见不能为空', trigger: 'blur' }],
        },
      }
    },
    methods: {
      // 提交
      modalConfirm() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            this.btnLoading = true
            apiActivity
              .apiActivitiesExamine(this.id, this.form)
              .then(res => {
                this.$Message.success('审核成功')
                this.$emit('on-success')
                this.modalCancel()
              })
              .finally(() => this.btnLoading = false)
          }
        })
      },
      modalCancel() {
        this.$refs['addForm'].resetFields()
        this.$nextTick(() => {
          this.modalValue = false
        })
      },
      statusChange(e) {
        this.form.remark = this.statusList.find(item => item.value == e).name
      },
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
  }
</script>
